import useHasListsToolAccess from 'automation-ui-enrollment/hooks/useHasListsToolAccess';
import useIlSListSize from 'automation-ui-enrollment/hooks/useILSListSize';
import { useEffect, useState } from 'react';
export const LARGE_LIST_SIZE_THRESHOLD = 50000;
const LONG_LOADING_THRESHOLD_MS = 7000;
const useEnrollmentListSizeExact = ({
  listId,
  objectTypeId
}) => {
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState(false);
  const {
    loading,
    error,
    listSize
  } = useIlSListSize({
    listId
  });
  const hasListsToolAccess = useHasListsToolAccess(objectTypeId);
  useEffect(() => {
    const timeoutId = setTimeout(() => setShowLongLoadingMessage(true), LONG_LOADING_THRESHOLD_MS);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return {
    error,
    loading,
    showLongLoadingMessage,
    showAccuracyDisclaimer: listSize !== undefined && listSize >= LARGE_LIST_SIZE_THRESHOLD,
    listSize,
    hasListsToolAccess
  };
};
export default useEnrollmentListSizeExact;